module.exports = __webpack_public_path__ + "img/nft5.a07672c5.jpg";